<script setup lang="ts">
import type { Schemas } from '#shopware'

const props = defineProps<{
    content: Schemas['CmsElementA4gHeadline']
}>()

const isFjallaOne = computed(() => props.content?.config?.fontFamily?.value === 'fjalla-one')

const isContentCentered = computed(() => props.content?.config?.centerContent?.value)

const semanticTag = computed(() => props.content?.config?.semanticTag?.value ?? 'div')

const visualHeadingSizeClass = computed(() =>
    props.content?.config?.visualHeadingSize?.value ?? 'text-4xl'
)

const blockTextColor = computed(() => {
    const color = props.content?.config?.textColor?.value
    return color ? { color } : undefined
})

const countdownUntil = computed(() => props.content?.config?.countdownUntil?.value || undefined)
</script>

<template>
    <div
        class="flex flex-wrap"
        :class="{
            'justify-center text-center': isContentCentered,
            'justify-between items-end': !isContentCentered && !countdownUntil,
            'justify-between items-baseline gap-x-4 gap-y-2': !isContentCentered && countdownUntil
        }"
        :style="blockTextColor"
    >
        <div :class="{ 'mr-8': isContentCentered && content?.config?.buttonText?.value }">
            <component
                :is="semanticTag"
                v-if="content?.config?.title?.value"
                :class="[
                    visualHeadingSizeClass,
                    {
                        'font-fjalla-one font-normal': isFjallaOne,
                        'font-semibold': !isFjallaOne,
                        'uppercase': content?.config?.isTitleAllCaps?.value,
                        'pb-3': content?.config?.subtitle?.value
                    }
                ]"
            >
                {{ content?.config?.title?.value }}
            </component>

            <div v-if="content?.config?.subtitle?.value">
                {{ content?.config?.subtitle?.value }}
            </div>
        </div>

        <div v-if="countdownUntil" class="flex items-baseline gap-1">
            <span class="text-xxs font-normal">{{ $t('structure.slot.headline.countdownTitle') }}</span>

            <LazyMiscCountdown
                :target-date="countdownUntil"
                value-class="font-bold text-base lg:text-xl"
                unit-class="text-xxs font-normal"
            />
        </div>

        <div v-if="content?.config?.buttonText?.value">
            <MiscLink
                :to="content?.config?.buttonTarget?.value"
                :target="content?.config?.buttonNewTab?.value ? '_blank' : undefined"
                class="btn bg-transparent hover:bg-transparent shadow-none border-none p-0"
            >
                {{ content?.config?.buttonText?.value }}
                <MiscIcon name="arrow-right" />
            </MiscLink>
        </div>
    </div>
</template>
